import React, { memo } from "react";

import { makeStyles } from "@material-ui/styles";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles({
  icon: {
    width: "1rem",
    height: "0.75rem",
    cursor: "default",
  },
});

const CheckmarkIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 16 12" className={styles.icon}>
      <path
        d="M5.09091 9.49254L1.27273 5.73134L0 6.98507L5.09091 12L16 1.25373L14.7273 0L5.09091 9.49254Z"
        fill="black"
        fillOpacity="0.87"
      />
    </SvgIcon>
  );
};

export default memo(CheckmarkIcon);
